import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import Breadcrumbs from '@material-ui/core/Breadcrumbs'
import { Button, Typography } from '@material-ui/core'
import { mapData } from '@/product/common/components'
import CustomSelect from '@/product/components/atoms/Inputs/CustomSelect'
import { useTranslation } from 'react-i18next'
import { useFormik } from 'formik'

const Commoncomp = (props) => {
    const formikSearch = props.formikSearch
    const sortShow = props.sortShow
    const pageOptions = props.pageOptions
    const { t } = useTranslation()

    const sortInfo = [
        {
            label: '',
            name: 'searchbar',
            type: 'text',
            placeholder: 'Search',
            class: 'sort-search',
            formik: formikSearch,
            filter: true,
        },
        {
            label: '',
            name: 'date_closed',
            type: 'date',
            placeholder: 'Date',
            class: 'sort-date',
            filter: true,
            formik: formikSearch,
        },
    ]

    useEffect(() => {
        if (props.additionalUpdate) {
            props.additionalUpdate(formikSearch.values)
        }
    }, [formikSearch.values])

    return (
        <>
            {/* <SEO title="My Bids gh" url={window.location.href} /> */}
            <div className="searchMiscFilters w-100 mb-3 d-flex justify-content-end align-items-end mt-4 ss-filters">
                {props.path && (
                    <Breadcrumbs aria-label="breadcrumb" className="customBreadcrumbs">
                        <Link to="/auctions/all">{location.pathname.split('/')[1]}</Link>
                        <Typography color="textPrimary">
                            {props.renderHeading(location.pathname.split('/')[2])}
                        </Typography>
                    </Breadcrumbs>
                )}
                <div className="searchMiscFilters ml-auto mb-3 d-flex justify-content-end align-items-end">
                    {props.viewSwitch && (
                        <div className="gridListToggle">
                            <Button
                                id="myauctions_grid"
                                className={props.auctionView === 'Grid' ? 'active' : ''}
                                onClick={() => props.setAuctionView('Grid')}
                            >
                                <span className="material-icons">apps</span>
                            </Button>
                            <Button
                                id="myauctions_list"
                                className={props.auctionView === 'List' ? 'active' : ''}
                                onClick={() => props.setAuctionView('List')}
                            >
                                <span className="material-icons">view_list</span>
                            </Button>
                        </div>
                    )}
                    {props.resultPerPage && (
                        <div className="d-flex align-center">
                            <label className="rpp-label">Results per page</label>
                            <CustomSelect
                                label=""
                                name="resultsPerPage"
                                selectType="noBorder"
                                size="small"
                                value={formikSearch.values.limit}
                                onChange={(event, editor) => {
                                    formikSearch.setFieldValue('limit', event.target.value)
                                }}
                            >
                                {pageOptions.map((opt, optindex) => (
                                    <option value={opt.value}>{opt.show}</option>
                                ))}
                            </CustomSelect>
                        </div>
                    )}
                    {props.sortBy && (
                        <CustomSelect
                            label=""
                            value={formikSearch.values.orderby}
                            size="small"
                            selectType="noBorder"
                            name="orderby"
                            // shrink={search.orderby !== '' ? true : false}
                            onChange={(event, editor) => {
                                formikSearch.setFieldValue('orderby', event.target.value)
                            }}
                        >
                            {sortShow.map((opt, optindex) => (
                                <option value={opt.value}>{opt.show}</option>
                            ))}
                        </CustomSelect>
                    )}
                </div>
            </div>
            {props.sortDate && <div className="sort-common-search">{mapData(sortInfo)}</div>}
        </>
    )
}

export default Commoncomp
